import { postApv } from '../../apis';
import { APV_ENDPOINT } from '../../constants';
import { getIframe, getLocationPath } from '../../helpers';

const CardRegi = {
  render: async () => {
    return ``;
  },
  afterRender: async () => {
    const brandInfo = JSON.parse(sessionStorage.getItem('CONPAY_BRAND_INFO'));
    const merchantId =
      brandInfo.bndBizDivCode == '1'
        ? process.env.SEEROO_MERCHANT_ID_OFFLINE
        : process.env.SEEROO_MERCHANT_ID_ONLINE;
    const memberId = sessionStorage.getItem('CONPAY_USER_KEY');

    const param = {
      bi: brandInfo.bid,
      id: merchantId,
      memberId,
      type: process.env.NODE_ENV == 'production' ? 'P' : 'T',
      closeUrl: `${getLocationPath()}#conpay_card-regi-close`,
      completeUrl: `${getLocationPath()}#conpay_card-regi-callback`,
      resultUrl: `${APV_ENDPOINT}/api/v1/apv/pub/callback/cardReg`,
    };

    const queryString = await postApv('common/cardRegReady', param);
    getIframe().location.replace(
      `${process.env.SEEROO_CARD_URL}?${queryString}`
    );
  },
};
export default CardRegi;
